"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidBrowser = exports["default"] = void 0;
var _uaParserJs = _interopRequireDefault(require("ua-parser-js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var HeadlessChrome = 'chrome headless';
var Chrome = 'chrome';
var Edge = 'edge';
var MacOS = 'mac os';
var Windows = 'windows';
var ValidBrowsers = [Chrome, Edge, HeadlessChrome];
var ValidOSes = [MacOS, Windows];
var isValidBrowser = function isValidBrowser() {
  var _uaResult$browser, _uaResult$os;
  var uaInstance = new _uaParserJs["default"]();
  var uaResult = uaInstance === null || uaInstance === void 0 ? void 0 : uaInstance.getResult();
  var browser = ((uaResult === null || uaResult === void 0 ? void 0 : (_uaResult$browser = uaResult.browser) === null || _uaResult$browser === void 0 ? void 0 : _uaResult$browser.name) || '').toLowerCase();
  var os = ((uaResult === null || uaResult === void 0 ? void 0 : (_uaResult$os = uaResult.os) === null || _uaResult$os === void 0 ? void 0 : _uaResult$os.name) || '').toLowerCase();
  var validBrowser = ValidBrowsers.includes(browser);
  var validOS = ValidOSes.includes(os);
  if (validBrowser && (validOS || browser === HeadlessChrome)) {
    return {
      valid: true,
      notice: ''
    };
  }
  return {
    valid: false,
    notice: 'It looks like you are using an unsupported device or a browser. Please reload this page in Chrome or Edge on a computer (Mac or PC).'
  };
};
exports.isValidBrowser = isValidBrowser;
var _default = isValidBrowser;
exports["default"] = _default;